module.exports = __webpack_public_path__ + "2738898924736779d518f2bfd549ed7b.pdf";